export default __webpack_public_path__ + "static/media/davids_light.7f01a399.svg";